// Экран входа (п.20, финал переезда 2026-09-07). Регистрация закрыта:
// пользователей заводит администратор на экране «Пользователи».
import { useState } from 'react';
import { call } from '../api';

export function Login({ onDone }: { onDone: (token: string) => void }) {
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    const r = await call<{ token: string; name: string | null }>('post', '/api/auth/login',
      { email: email.trim(), password: pwd });
    setBusy(false);
    if (!r.ok) { setErr(r.error.message); return; }
    try { localStorage.setItem('plot_t', r.data.token); } catch { /* приватный режим */ }
    onDone(r.data.token);
  }

  return (
    <div className="wrap">
      <div className="card login">
        <h1>Каскад</h1>
        <div className="login-podpis">Умное планирование жилого строительства</div>
        <input type="email" placeholder="Почта" autoComplete="username" value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') void submit(); }} />
        <input type="password" placeholder="Пароль" autoComplete="current-password" value={pwd}
          onChange={e => setPwd(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') void submit(); }} />
        <button disabled={busy} onClick={() => void submit()}>{busy ? 'Проверяю…' : 'Войти'}</button>
        <div className="err">{err}</div>
        <div className="muted">Нет аккаунта или забыли пароль — обратитесь к администратору проекта.</div>
      </div>
    </div>
  );
}
